import { Container } from 'inversify';
import { SettingsInterface, SettingsService } from './settings.service';

export const settingsContainer = new Container();
settingsContainer.bind<SettingsInterface>(SettingsService).toSelf().inSingletonScope();
